import useToggleStyle from 'hooks/useToggleStyle';
import { useAppContext } from 'providers/AppProvider';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import ErrorBoundary from 'ErrorBoundary';
import useAutoPageTitle from 'hooks/useAutoPageTitle';

import { initVersionAutoReload } from './helpers/versionWatcher';

const App = () => {
  const { isStylesheetLoaded } = useToggleStyle();
  const { pathname } = useLocation();

  const {
    config: { theme },
  } = useAppContext();

  useAutoPageTitle();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const cleanup = initVersionAutoReload(60000);
    return cleanup;
  }, []);

  return (
    <>
      {!isStylesheetLoaded ? (
        <div
          style={{
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: theme === 'dark' ? '#000' : '#fff',
          }}
        />
      ) : (
        <Outlet />
      )}
    </>
  );
};

export default App;
